import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { TranslationProvider, useTranslation } from '@ibk/shared-translation';
import { beneficiosTranslations } from '../../../../translations';
import { HiringFeedbackLayout } from '../HiringFeedback';
import styles from './HiringError.module.css';
function HiringErrorContent({ onGoToBenefits }) {
    const { t } = useTranslation();
    return (_jsx(HiringFeedbackLayout, { iconName: 'circleError', iconAlt: t('activation.error.iconAlt'), iconClassName: styles.errorIcon, iconContainerClassName: `${styles.iconContainer} ${styles.errorIconContainer}`, title: t('activation.error.title'), description: t('activation.error.description'), buttonLabel: t('activation.error.button'), onGoToBenefits: onGoToBenefits }));
}
export function HiringError({ onGoToBenefits }) {
    return (_jsx(TranslationProvider, { translations: beneficiosTranslations, defaultLanguage: 'pt-BR', children: _jsx(HiringErrorContent, { onGoToBenefits: onGoToBenefits }) }));
}
